import { render } from "./HomePage.vue?vue&type=template&id=4bc12bf7&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=4bc12bf7&scoped=true&lang=css"
import "./HomePage.vue?vue&type=style&index=1&id=4bc12bf7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc12bf7"]])

export default __exports__